import React from 'react'
import { gsap, Power2, ScrollTrigger } from 'gsap/all'

gsap.registerPlugin(ScrollTrigger)

class Quote extends React.Component {
    constructor(props) {
        super(props)

        this.domRef = React.createRef()
    }

    componentDidMount() {
        document.addEventListener('allimagesloaded', () => {
            gsap.timeline({
                ease: Power2.easeOut,
                scrollTrigger: {
                    trigger: this.domRef.current,
                    toggleActions: 'restart',
                    start: 'top bottom',
                    end: 'top 60%',
                    scrub: true
                }
            })
                .from(this.domRef.current.querySelector('.text'), {
                    x: this.props.alignRight ? -500 : 500,
                    opacity: 0
                })
                .from(this.domRef.current.querySelector('cite'), {
                    x: this.props.alignRight ? 500 : -500,
                    opacity: 0
                }, '-=0.5')
        })
    }

    render() {
        const { alignRight, cite, maxWidth, children } = this.props

        return (
            <blockquote className={alignRight && 'align-right'} style={{ maxWidth: maxWidth }} ref={this.domRef}>
                <div className="text">
                    {children}
                </div>
                <cite>{cite}</cite>
            </blockquote>
        )
    }
}

export default Quote